export const PAID_PLANS = [
  {
    id: "starter",
    name: "Starter",
    price: "$49",
    audience: "Solo operators",
    contacts: "2,500",
    seats: 1,
    crmConnections: 1,
    features: [
      "Unlimited cleaning jobs*",
      "Duplicate detection and guided review",
      "Email, phone, and address quality checks",
      "Quality scoring and approval controls",
      "Approval-gated CRM write-back",
      "1 CRM connection · 1 CleanIQ user",
    ],
  },
  {
    id: "growth",
    name: "Growth",
    price: "$99",
    audience: "Growing agencies",
    contacts: "10,000",
    seats: 3,
    crmConnections: 3,
    popular: true,
    features: [
      "Everything in Starter",
      "Priority scan processing",
      "Bulk delete controls with confirmation",
      "Up to 3 CRM connections",
      "Job history and audit records",
      "Up to 3 CleanIQ users",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: "$199",
    audience: "Large operations",
    contacts: "50,000",
    seats: 10,
    crmConnections: 10,
    features: [
      "Everything in Growth",
      "Highest scan processing priority",
      "Up to 10 CRM connections",
      "High-volume 50,000-contact scanning",
      "Job history and audit records",
      "Up to 10 CleanIQ users",
    ],
  },
];

export const PLAN_OPERATIONAL_NOTE =
  "Unlimited by job count; one active scan per CRM, a 30-second manual-scan cooldown, and plan contact ceilings apply.";
